// apps/roleforge-app/src/components/audit/AssetCard.tsx
//
// A single asset preview in the right column. Click → opens the full asset
// editor in the middle column.

interface Props {
  assetId: string;
  title: string;
  subtitle?: string;
  metric?: string;
  active?: boolean;
  onClick: () => void;
}

export function AssetCard({ assetId, title, subtitle, metric, active, onClick }: Props) {
  return (
    <button
      type="button"
      data-testid={`asset-card-${assetId}`}
      data-active={active ? 'true' : 'false'}
      onClick={onClick}
      className={`group flex w-full flex-col gap-2 rounded-xl border bg-card p-4 text-left transition-colors ${
        active
          ? 'border-plum shadow-[0_2px_8px_rgba(122,82,168,0.18)]'
          : 'border-line hover:border-plum/60 hover:shadow-sm'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <h3 className="text-sm font-semibold text-ink">{title}</h3>
        {metric && (
          <span className="rounded-full bg-mint/10 px-2 py-0.5 text-[11px] font-semibold text-mint">
            {metric}
          </span>
        )}
      </div>
      {subtitle && <p className="text-xs text-graphite">{subtitle}</p>}
      <span className="mt-auto text-[11px] uppercase tracking-wide text-slate-400 group-hover:text-plum">
        Open →
      </span>
    </button>
  );
}
